import React from "react";
import { makeStyles } from "@material-ui/core";
import About from "./About";
import Product from "./Product";
import landingpagegif from "../../../assets/Images/landingpagegif.mp4";
import Work from "./Work";
import Why from "./Why";

const customStyles = makeStyles({
  root: {
    position: "relative",
    zIndex: 1,
    paddingTop: 0,
    marginTop:"70px",
  },
  videoWrapper: {
    position: "relative",
    overflow: "hidden",
    zIndex: 0,
    borderRadius:"10px",
    marginTop:"-60px",

  },
  videoBG: {
    width: "100%",
    height: "100%",
    objectFit: "cover", // Ensures full cover on all screens
    position: "absolute",
    top: 0,
    left: 0,
    zIndex: -1,

  },
  contentOverlay: {
    position: "relative",
    zIndex: 2,
    backgroundColor: "#fff",
  },
  headerWrapper: {
    width: "100%",
    display: "flex",
    position: "relative",
    flexWrap: "wrap",
    alignContent: "flex-start",
    flexDirection: "column",
    fontFamily: "Poppins",  
    marginTop:"170px",
    marginLeft:"-20px",
    marginBottom:"180px"
  

  },
  headerContainer: {
    textAlign: "left",
    maxWidth: "700px",

  },
  header: {
    margin: "0px",
    fontWeight: "600",
    letterSpacing: "-0.027em",
    lineHeight: "1.1",
    textTransform: "none",
    fontSize: "64px",
    fontWeight: "600", 
    marginLeft: "70px",
    fontFamily: "Poppins",  

  },
  headerBodyContainer: {
    marginTop: "20px",
    maxWidth: "520px",
    fontSize: "20px",
    fontWeight: "300",
    marginLeft: "70px",
    fontFamily:"Roboto"

  },
 
});

const Layout = () => {
  const classes = customStyles();

  return (
    <div className={classes.root}>
      <div className={classes.videoWrapper}>
        <video
          autoPlay
          muted
          playsInline
          loop
          className={classes.videoBG}
          src={landingpagegif}
        />
         <div className={classes.headerWrapper}>
      <div className={classes.headerContainer}>
        <h1 className={classes.header}>
          Redefining the way you receive  deliveries.
        </h1>
      </div>
      <div className={classes.headerBodyContainer}>
        SMART, SECURE AND BUILT FOR TODAY
      </div>
    </div>
        <div  />
      </div>
      {/* <Header/> */}
      <div className={classes.contentOverlay}>
        <About />
        <Work/>
        <Product />
        <Why/>
      </div>
    </div>
  );
};

export default Layout;
